export { default } from "./src/video-carousel";

export type { UniformVideoCarouselProps } from "./src/video-carousel";
